import React from 'react';
import PropTypes from 'prop-types';
import { sanitize } from '@americanexpress/consumer-travel-base';
import { Link, AccordionContent, AccordionPanel } from '@americanexpress/dls-react';
import {
  IconAirplane, IconCar, IconHotel, IconLounge,
  IconPoint2x, IconPoint3x, IconPoint5x, IconRewards, IconTravelBag,
} from '@americanexpress/dls-icons';
import styles from './TravelBenefits.scss';

const Benefit = ({
  analyticsDetail,
  benefit: {
    icon,
    heading,
    bodyText,
    ctaLabel,
    ctaRedirectUrl,
    analyticElement,
  },
}) => {
  const name = heading.replace(/\s/g, '');
  const panelId = `${analyticsDetail}-${name}`;

  const benefitIconMap = {
    IconRewards: <IconRewards />,
    IconHotel: <IconHotel />,
    IconAirplane: <IconAirplane />,
    IconPoint2x: <IconPoint2x />,
    IconPoint3x: <IconPoint3x />,
    IconPoint5x: <IconPoint5x />,
    IconLounge: <IconLounge />,
    IconTravelBag: <IconTravelBag />,
    IconCar: <IconCar />,
  };

  return (
    <>
      <AccordionPanel
        className={styles.accordionPanel}
        id={panelId}
        data-testid="benefit-panel"
        icon={benefitIconMap[icon]}
        reactlytics={{
          element: analyticElement,
          detail: analyticsDetail,
        }}
        heading={<h3>{heading}</h3>}
      />
      <AccordionContent aria-labelledby={panelId}>
        <p className="pad-1-lr">
          <span
            // eslint-disable-next-line react/no-danger -- sanitized
            dangerouslySetInnerHTML={{ __html: sanitize(bodyText) }}
          />
          {ctaRedirectUrl && (
            <Link href={ctaRedirectUrl} isInline={true}>
              {ctaLabel}
            </Link>
          )}
        </p>
      </AccordionContent>
    </>
  );
};

Benefit.propTypes = {
  analyticsDetail: PropTypes.string.isRequired,
  benefit: PropTypes.shape({
    heading: PropTypes.string,
    icon: PropTypes.string,
    ctaRedirectUrl: PropTypes.string,
    ctaLabel: PropTypes.string,
    bodyText: PropTypes.string,
    name: PropTypes.string,
    analyticElement: PropTypes.string,
  }).isRequired,
};

export { Benefit as TestableBenefit };

export default Benefit;
